import { useEffect, useState } from 'react';

/**
 * Latches to true the first time `isLoading` turns false and stays true
 * through background refetches. The endpoint wrapper's `*IsLoading` flags
 * map to TanStack's `isFetching`, which also fires on invalidations — UI
 * gated on them directly unmounts and flashes on every refetch.
 */
export const useLoadedOnce = (isLoading: boolean): boolean => {
  const [loaded, setLoaded] = useState(!isLoading);

  useEffect(() => {
    if (!isLoading) setLoaded(true);
  }, [isLoading]);

  return loaded;
};
